import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/image/close-icon-black.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-a545fd72")

_pushScopeId("data-v-a545fd72")
const _hoisted_1 = { class: "ui_photoList_header" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = { class: "ui__photoList_Box" }
const _hoisted_4 = { class: "ui__photoList_title" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_6 = { class: "ui__photoList_swiperModel" }
const _hoisted_7 = { class: "ui__photoList_bannerBox" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_swiperComponent = _resolveComponent("swiperComponent")

  return (_openBlock(), _createBlock("div", {
    class: "ui__photoList_main",
    style: {minHeight:_ctx.state.clientHeight + 'px'}
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: "ui__pageTitle_left",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
      }, [
        _hoisted_2
      ])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.listTab, (item) => {
          return (_openBlock(), _createBlock("div", {
            class: ["ui__photoList_tab", {'ui__actTab':item.id === _ctx.state.actTab}],
            key: item.id,
            onClick: ($event: any) => (_ctx.changeActTab(item.id))
          }, [
            _createVNode("span", null, _toDisplayString(item.name), 1),
            _hoisted_5
          ], 10, ["onClick"]))
        }), 128))
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_swiperComponent, {
            imgList: _ctx.state.swiperPhotoList,
            initialSlide: _ctx.state.initialSlideSwiper,
            onSlideChange: _ctx.slideChange
          }, null, 8, ["imgList", "initialSlide", "onSlideChange"])
        ])
      ])
    ])
  ], 4))
})